import { updateState } from "./counterSlice.js";

export default function updateActiveTopicHrefSearchPath({
  dispatch,
  activeTopicHRefSearchPath,
  mpsPathJS,
  selectedHref,
  header,
  isEnhancedBrowserHistoryButton,
}) {
  // Maintain enhanced history stack
  // Make a safe copy activeTopicHRefSearchPath its redux state
  const activePathStack = activeTopicHRefSearchPath || [];
  // Reverse safely (copy first)
  const checkInStackIndex = [...activePathStack]
    ?.reverse()
    .findIndex((item) => item.mpsPath === mpsPathJS && item.selectedTopicHref === selectedHref);
  console.log(
    "-----2---updateActiveTopicHrefSearchPath--checkInStackIndex",
    checkInStackIndex,
    "  activePathStack ",
    activePathStack,
    "  mpsPathJS",
    mpsPathJS,
    "header",
    header,
  );
  if (isEnhancedBrowserHistoryButton && mpsPathJS) {
    let newStack;
    if (checkInStackIndex !== -1) {
      console.log("-----3---already exist updatestate header", header);
      // ✅ It already exists — move it to the end
      const itemToMove = activePathStack[checkInStackIndex];

      newStack = [
        ...activePathStack.slice(0, checkInStackIndex),
        ...activePathStack.slice(checkInStackIndex + 1),
        itemToMove, // moved to end
      ];
    } else {
      // ✅ Not in stack — add new item
      newStack = [
        ...activePathStack,
        { mpsPath: mpsPathJS, selectedTopicHref: selectedHref, header },
      ];
      console.log("-----3--updateActiveTopicHrefSearchPath-- new---updatestate header", header);
    }
    dispatch(updateState({ activeTopicHRefSearchPath: newStack }));
  }
}
